(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9195],{

/***/ 29387:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t={year:0,month:1,day:2,hour:3,minute:4,second:5},e={};return function(n,i,o){var r,a=function(t,n,i){void 0===i&&(i={});var o=new Date(t),r=function(t,n){void 0===n&&(n={});var i=n.timeZoneName||"short",o=t+"|"+i,r=e[o];return r||(r=new Intl.DateTimeFormat("en-US",{hour12:!1,timeZone:t,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit",timeZoneName:i}),e[o]=r),r}(n,i);return r.formatToParts(o)},u=function(e,n){for(var i=a(e,n),r=[],u=0;u<i.length;u+=1){var f=i[u],s=f.type,m=f.value,c=t[s];c>=0&&(r[c]=parseInt(m,10))}var d=r[3],l=24===d?0:d,h=r[0]+"-"+r[1]+"-"+r[2]+" "+l+":"+r[4]+":"+r[5]+":000",v=+e;return(o.utc(h).valueOf()-(v-=v%1e3))/6e4},f=i.prototype;f.tz=function(t,e){void 0===t&&(t=r);var n=this.utcOffset(),i=this.toDate(),a=i.toLocaleString("en-US",{timeZone:t}),u=Math.round((i-new Date(a))/1e3/60),f=o(a,{locale:this.$L}).$set("millisecond",this.$ms).utcOffset(15*-Math.round(i.getTimezoneOffset()/15)-u,!0);if(e){var s=f.utcOffset();f=f.add(n-s,"minute")}return f.$x.$timezone=t,f},f.offsetName=function(t){var e=this.$x.$timezone||o.tz.guess(),n=a(this.valueOf(),e,{timeZoneName:t}).find((function(t){return"timezonename"===t.type.toLowerCase()}));return n&&n.value};var s=f.startOf;f.startOf=function(t,e){if(!this.$x||!this.$x.$timezone)return s.call(this,t,e);var n=o(this.format("YYYY-MM-DD HH:mm:ss:SSS"),{locale:this.$L});return s.call(n,t,e).tz(this.$x.$timezone,!0)},o.tz=function(t,e,n){var i=n&&e,a=n||e||r,f=u(+o(),a);if("string"!=typeof t)return o(t).tz(a);var s=function(t,e,n){var i=t-60*e*1e3,o=u(i,n);if(e===o)return[i,e];var r=u(i-=60*(o-e)*1e3,n);return o===r?[i,o]:[t-60*Math.min(o,r)*1e3,Math.max(o,r)]}(o.utc(t,i).valueOf(),f,a),m=s[0],c=s[1],d=o(m).utcOffset(c);return d.$x.$timezone=a,d},o.tz.guess=function(){return Intl.DateTimeFormat().resolvedOptions().timeZone},o.tz.setDefault=function(t){r=t}}}));

/***/ }),

/***/ 57286:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(97479);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atomic/Breadcrumbs/breadcrumbs.module.scss
var breadcrumbs_module = __webpack_require__(96526);
var breadcrumbs_module_default = /*#__PURE__*/__webpack_require__.n(breadcrumbs_module);
;// CONCATENATED MODULE: ./components/atomic/Breadcrumbs/Breadcrumbs.js







var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs, _hasMaxWidth = param.hasMaxWidth, hasMaxWidth = _hasMaxWidth === void 0 ? false : _hasMaxWidth;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: breadcrumbs.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    children: '\n              {\n                "@context": "https://schema.org",\n                "@type": "BreadcrumbList",\n                "itemListElement": ['.concat(breadcrumbs.map(function(breadcrumb, index) {
                        return JSON.stringify({
                            "@type": "ListItem",
                            position: "".concat(index + 1),
                            name: "".concat(breadcrumb.title),
                            item: "https://www.leaseloco.com".concat(breadcrumb.slug ? breadcrumb.slug : router.asPath.split("?")[0])
                        });
                    }), "]\n              }\n            ")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                "aria-label": "breadcrumb",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                    className: "".concat((breadcrumbs_module_default()).list, " ").concat(hasMaxWidth ? (breadcrumbs_module_default())["has-max-width"] : ""),
                    children: breadcrumbs.map(function(crumb, index) {
                        if (!crumb.slug) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: (breadcrumbs_module_default())["breadcrumb-item"],
                                "aria-current": "page",
                                children: crumb.title
                            }, crumb.title ? crumb.title : index);
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (breadcrumbs_module_default())["breadcrumb-item"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: crumb.slug,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: crumb.title
                                })
                            })
                        }, crumb.title ? crumb.title : index);
                    })
                })
            })
        ]
    });
};
Breadcrumbs.propTypes = {
    breadcrumbs: (prop_types_default()).array.isRequired,
    hasMaxWidth: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./components/atomic/Breadcrumbs/index.js



/***/ }),

/***/ 54131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ Loader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
;// CONCATENATED MODULE: ./components/atomic/Loader/Loader.tsx



var Loader = function(param) {
    var _message = param.message, message = _message === void 0 ? "Loading..." : _message;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "loader--search",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/general/loading.gif"),
                alt: "loading",
                height: "75",
                width: "75",
                rel: "prefetch"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-2",
                children: message
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/atomic/Loader/index.ts



/***/ }),

/***/ 29099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* reexport */ PageContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atomic/PageContainer/PageContainer.tsx

var PageContainer = function(param) {
    var children = param.children, _containerClass = param.containerClass, containerClass = _containerClass === void 0 ? "" : _containerClass;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
        className: "container container--body ".concat(containerClass),
        children: children
    });
};

;// CONCATENATED MODULE: ./components/atomic/PageContainer/index.ts



/***/ }),

/***/ 19674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _pagination_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57807);
/* harmony import */ var _pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99280);








var Pagination = function(param) {
    var resultTotal = param.resultTotal, pageSize = param.pageSize, currentPage = param.currentPage, gotoPage = param.gotoPage;
    var getNumberOfPages = function(pageSize, resultTotal) {
        return Math.ceil(resultTotal / pageSize);
    };
    var isPreviousButtonDisabled = function(currentPage, totalPages) {
        return currentPage === 1 || totalPages === 0;
    };
    var isNextButtonDisabled = function(currentPage, totalPages) {
        return currentPage === totalPages || totalPages === 1 || totalPages === 0;
    };
    var pageUrl = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().asPath.split("?")[0];
    var totalPages = getNumberOfPages(pageSize, resultTotal);
    var isMobile = (0,react_responsive__WEBPACK_IMPORTED_MODULE_4__.useMediaQuery)({
        maxWidth: 991
    });
    var numberOfPagesDesktop = 5;
    var numberOfPagesMobile = 3;
    var maxPagesToDisplay = isMobile ? numberOfPagesMobile : numberOfPagesDesktop;
    var handleChange = function(page) {
        if (gotoPage) {
            gotoPage(page);
        }
    };
    var getPagesToDisplay = function(currentPage, totalPages) {
        var pages = [];
        var numberOfPagesToDisplay = maxPagesToDisplay > totalPages ? totalPages : maxPagesToDisplay;
        if (currentPage === 1 || currentPage === 2 || currentPage === 3) {
            // currentPage is at the minimum
            for(var i = 1; i <= numberOfPagesToDisplay; i++){
                pages.push(i);
            }
        } else if (currentPage + 2 < totalPages && currentPage - 2 > 1) {
            // currentPage is in the middle
            for(var i1 = currentPage - 2; i1 <= currentPage + 2; i1++){
                pages.push(i1);
            }
        } else if (currentPage === totalPages || currentPage === totalPages - 1 || currentPage === totalPages - 2) {
            // currentPage is up at the maximum
            for(var i2 = totalPages - numberOfPagesToDisplay === 0 ? 1 : totalPages - numberOfPagesToDisplay; i2 <= totalPages; i2++){
                pages.push(i2);
            }
        }
        return pages;
    };
    var pages = getPagesToDisplay(currentPage, totalPages).map(function(pageId) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            className: "".concat((_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-item"]), " ").concat(pageId === currentPage ? (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default().active) : ""),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "".concat(pageUrl, "?page=").concat(pageId),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    className: (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-link"]),
                    onClick: function() {
                        return handleChange(pageId);
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "sr-only",
                            children: "Page "
                        }),
                        pageId
                    ]
                })
            })
        }, pageId);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
        "aria-label": "Page navigation",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
            className: (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default().pagination),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "".concat((_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-item"]), " ").concat(isPreviousButtonDisabled(currentPage, totalPages) ? (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default().disabled) : ""),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: "".concat(pageUrl, "?page=1"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-link"]),
                            onClick: function() {
                                return handleChange(1);
                            },
                            "aria-label": "First",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    src: "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_5__/* .constants.imageHost.assets */ ._G.imageHost.assets, "/icons/library/chevrons-left.svg"),
                                    alt: "",
                                    height: "16",
                                    width: "16"
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "".concat((_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-item"]), " ").concat(isPreviousButtonDisabled(currentPage, totalPages) ? (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default().disabled) : ""),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: "".concat(pageUrl, "?page=").concat(currentPage - 1),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-link"]),
                            onClick: function() {
                                return handleChange(currentPage - 1);
                            },
                            "aria-label": "Previous",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    src: "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_5__/* .constants.imageHost.assets */ ._G.imageHost.assets, "/icons/library/chevron-left.svg"),
                                    alt: "chevron left icon",
                                    height: "16",
                                    width: "16"
                                })
                            })
                        })
                    })
                }),
                pages,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "".concat((_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-item"]), " ").concat(isNextButtonDisabled(currentPage, totalPages) ? (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default().disabled) : ""),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: "".concat(pageUrl, "?page=").concat(currentPage + 1),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-link"]),
                            onClick: function() {
                                return handleChange(currentPage + 1);
                            },
                            "aria-label": "Next",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    src: "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_5__/* .constants.imageHost.assets */ ._G.imageHost.assets, "/icons/library/chevron-right.svg"),
                                    alt: "chevron right icon",
                                    height: "16",
                                    width: "16"
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "".concat((_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-item"]), " ").concat(isNextButtonDisabled(currentPage, totalPages) ? (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default().disabled) : ""),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: "".concat(pageUrl, "?page=").concat(totalPages),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-link"]),
                            onClick: function() {
                                return handleChange(totalPages);
                            },
                            "aria-label": "Last",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                src: "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_5__/* .constants.imageHost.assets */ ._G.imageHost.assets, "/icons/library/chevrons-right.svg"),
                                alt: "",
                                height: "16",
                                width: "16"
                            })
                        })
                    })
                })
            ]
        })
    });
};
Pagination.propTypes = {
    resultTotal: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number.isRequired),
    pageSize: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number.isRequired),
    currentPage: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number.isRequired),
    gotoPage: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func.isRequired)
};


/***/ }),

/***/ 65299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ ChatWidget; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var system = __webpack_require__(70591);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/styleguide/ChatWidget/ChatWidget.tsx



var ChatWidget = function() {
    if (!(0,system/* isProd */.BB)() || !"0e82ae7a-23e7-4571-a768-93f6cea963b2") {
        return false;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        id: "ze-snippet",
        strategy: "lazyOnload",
        src: "https://static.zdassets.com/ekr/snippet.js?key=".concat("0e82ae7a-23e7-4571-a768-93f6cea963b2")
    });
};

;// CONCATENATED MODULE: ./components/styleguide/ChatWidget/index.ts



/***/ }),

/***/ 63392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AJ": function() { return /* binding */ getCustomerTestimonialsService; },
/* harmony export */   "oF": function() { return /* binding */ getPageContentListService; }
/* harmony export */ });
/* unused harmony exports getAdvancedLandingPageDealService, getPageContentItemService, getFaqArticleContentService, getCareersContentService */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34727);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var _endpoints__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19931);
/* harmony import */ var _restService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39177);





var getAdvancedLandingPageDealService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(adReference) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _restService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .endpointKeys.advancedLandingPageDeal */ .l.advancedLandingPageDeal, {
                            adReference: adReference
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getAdvancedLandingPageDealService(adReference) {
        return _ref.apply(this, arguments);
    };
}();
var getPageContentListService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(params) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _restService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .endpointKeys.pageContentList */ .l.pageContentList, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, params))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getPageContentListService(params) {
        return _ref.apply(this, arguments);
    };
}();
var getPageContentItemService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(params) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _restService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .endpointKeys.pageContent */ .l.pageContent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, params))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getPageContentItemService(params) {
        return _ref.apply(this, arguments);
    };
}();
var getFaqArticleContentService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _restService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .endpointKeys.faqArticles */ .l.faqArticles)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getFaqArticleContentService() {
        return _ref.apply(this, arguments);
    };
}();
var getCareersContentService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _restService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .endpointKeys.careers */ .l.careers)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getCareersContentService() {
        return _ref.apply(this, arguments);
    };
}();
var getCustomerTestimonialsService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _restService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(_endpoints__WEBPACK_IMPORTED_MODULE_0__/* .endpointKeys.testimonials */ .l.testimonials)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getCustomerTestimonialsService() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 97479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ blog; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-awesome-reveal/dist/index.js + 1 modules
var dist = __webpack_require__(81277);
// EXTERNAL MODULE: ./node_modules/react-masonry-css/dist/react-masonry-css.module.js
var react_masonry_css_module = __webpack_require__(40827);
// EXTERNAL MODULE: ./components/atomic/Breadcrumbs/index.js + 1 modules
var Breadcrumbs = __webpack_require__(52321);
// EXTERNAL MODULE: ./components/atomic/Loader/index.ts + 1 modules
var Loader = __webpack_require__(54131);
// EXTERNAL MODULE: ./components/atomic/PageContainer/index.ts + 1 modules
var PageContainer = __webpack_require__(29099);
// EXTERNAL MODULE: ./components/atomic/PageMetaData/index.ts + 1 modules
var PageMetaData = __webpack_require__(1429);
// EXTERNAL MODULE: ./components/atomic/Pagination/Pagination.js
var Pagination = __webpack_require__(19674);
;// CONCATENATED MODULE: ./components/atomic/Pagination/index.js


// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/ChatWidget/index.ts + 1 modules
var ChatWidget = __webpack_require__(65299);
// EXTERNAL MODULE: ./components/styleguide/Header/index.ts + 9 modules
var Header = __webpack_require__(638);
// EXTERNAL MODULE: ./components/styleguide/Link/index.ts + 1 modules
var Link = __webpack_require__(63383);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/routes.js
var routes = __webpack_require__(7158);
// EXTERNAL MODULE: ./lib/services/pageService.js
var pageService = __webpack_require__(63392);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./pages/blog/index.js






















var breakpointColumns = {
    default: 4,
    1200: 3,
    992: 2,
    576: 1
};
var BlogPage = function(param) {
    var articles = param.articles;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(constants/* constants.componentStatus.LOADING */._G.componentStatus.LOADING), status = ref[0], setStatus = ref[1];
    var ref1 = (0,react.useState)(articles.items), blogList = ref1[0], setBlogList = ref1[1];
    var ref2 = (0,react.useState)(router.query.page ? router.query.page : 1), currentPage = ref2[0], setCurrentPage = ref2[1];
    var ref3 = (0,react.useState)(articles.totalCount), totalCount = ref3[0], setTotalCount = ref3[1];
    (0,react.useEffect)(function() {
        var requestParams = {
            type: "BLOG",
            page: currentPage.toString(),
            pageSize: 12
        };
        function fetchData(requestParams) {
            return _fetchData.apply(this, arguments);
        }
        function _fetchData() {
            _fetchData = (0,_async_to_generator/* default */.Z)(function(requestParams) {
                var response, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,pageService/* getPageContentListService */.oF)(requestParams)
                            ];
                        case 1:
                            response = _state.sent();
                            setBlogList(response.items);
                            setTotalCount(response.totalCount);
                            return [
                                2,
                                setStatus(constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE)
                            ];
                        case 2:
                            err = _state.sent();
                            if (err.status === 404) {
                                return [
                                    2,
                                    setStatus(constants/* constants.componentStatus.NOT_FOUND */._G.componentStatus.NOT_FOUND)
                                ];
                            } else {
                                return [
                                    2,
                                    setStatus(constants/* constants.componentStatus.ERROR */._G.componentStatus.ERROR)
                                ];
                            }
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchData.apply(this, arguments);
        }
        fetchData(requestParams);
    }, [
        currentPage
    ]);
    var onClickMore = function(page) {
        setCurrentPage(page);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMetaData/* PageMetaData */.S, {
                title: "LeaseLoco Blog: Car Leasing News, Industry Updates & More",
                description: "Take a pit stop, grab all the latest car leasing news, industry insight and more on the LeaseLoco blog. The UK's leading car leasing comparison site.",
                pageUrl: routes/* ROUTES.blogPage.url */.Z.blogPage.url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatWidget/* ChatWidget */.A, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
                backgroundColor: "white",
                backButtonUrl: routes/* ROUTES.homePage.url */.Z.homePage.url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageContainer/* PageContainer */._, {
                containerClass: "container--blog",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* Breadcrumbs */.O, {
                        breadcrumbs: [
                            {
                                title: "Home",
                                slug: routes/* ROUTES.homePage.url */.Z.homePage.url
                            },
                            {
                                title: "Leasing Blog",
                                slug: null
                            }, 
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: "Leasing Blog"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Welcome to the LeaseLoco blog Amigos! We're the biggest",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: routes/* ROUTES.homePage.url */.Z.homePage.url,
                                children: " car leasing comparison site"
                            }),
                            " in the UK, with millions of lease deals available. Here on the blog we add extra insight from our leasing experts as well as the latest car industry news and updates."
                        ]
                    }),
                    status === constants/* constants.componentStatus.LOADING */._G.componentStatus.LOADING ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "d-flex justify-content-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {})
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react_masonry_css_module/* default */.Z, {
                        breakpointCols: breakpointColumns,
                        className: "masonry-grid",
                        columnClassName: "masonry-grid_column",
                        children: blogList.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                                triggerOnce: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "blog__card",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: item.content.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: item.content.thumbnail,
                                            alt: item.content.thumbnailAlt,
                                            height: 273,
                                            width: 487
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: item.content.description
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                                            href: "/blog/".concat(item.urlKey),
                                            size: system/* Size.Medium */.$u.Medium,
                                            hierarchy: Button/* ButtonHierarchy.Filled */.B.Filled,
                                            hasPadding: true,
                                            hasBackground: true,
                                            children: "Continue Reading"
                                        })
                                    ]
                                })
                            }, item.id);
                        })
                    }),
                    status === constants/* constants.componentStatus.ERROR */._G.componentStatus.ERROR && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "alert alert-warning my-3",
                        role: "alert",
                        children: "There has been an issue fetching the FAQs. Please try again later."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* Pagination */.t, {
                        resultTotal: totalCount,
                        pageSize: 12,
                        currentPage: Number(currentPage),
                        gotoPage: onClickMore
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var blog = (BlogPage);


/***/ }),

/***/ 96526:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"breadcrumbs_list__7kiNO","has-max-width":"breadcrumbs_has-max-width__uFJVk","breadcrumb":"breadcrumbs_breadcrumb__WZiF_","breadcrumb-item":"breadcrumbs_breadcrumb-item__7nfbQ","phAnimation":"breadcrumbs_phAnimation__LRHHK"};

/***/ }),

/***/ 57807:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_pagination___LfPQ","page-item":"pagination_page-item__XEnhm","page-link":"pagination_page-link__yj4U2","active":"pagination_active__GQYRT","disabled":"pagination_disabled__TnM8X","phAnimation":"pagination_phAnimation__2Zgxw"};

/***/ }),

/***/ 40827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
const defaultProps = {
  breakpointCols: undefined,
  // optional, number or object { default: number, [key: number]: number }
  className: undefined,
  // required, string
  columnClassName: undefined,
  // optional, string
  // Any React children. Typically an array of JSX items
  children: undefined,
  // Custom attributes, however it is advised against
  // using these to prevent unintended issues and future conflicts
  // ...any other attribute, will be added to the container
  columnAttrs: undefined,
  // object, added to the columns
  // Deprecated props
  // The column property is deprecated.
  // It is an alias of the `columnAttrs` property
  column: undefined
};
const DEFAULT_COLUMNS = 2;

class Masonry extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props); // Correct scope for when methods are accessed externally

    this.reCalculateColumnCount = this.reCalculateColumnCount.bind(this);
    this.reCalculateColumnCountDebounce = this.reCalculateColumnCountDebounce.bind(this); // default state

    let columnCount;

    if (this.props.breakpointCols && this.props.breakpointCols.default) {
      columnCount = this.props.breakpointCols.default;
    } else {
      columnCount = parseInt(this.props.breakpointCols) || DEFAULT_COLUMNS;
    }

    this.state = {
      columnCount
    };
  }

  componentDidMount() {
    this.reCalculateColumnCount(); // window may not be available in some environments

    if (window) {
      window.addEventListener('resize', this.reCalculateColumnCountDebounce);
    }
  }

  componentDidUpdate() {
    this.reCalculateColumnCount();
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this.reCalculateColumnCountDebounce);
    }
  }

  reCalculateColumnCountDebounce() {
    if (!window || !window.requestAnimationFrame) {
      // IE10+
      this.reCalculateColumnCount();
      return;
    }

    if (window.cancelAnimationFrame) {
      // IE10+
      window.cancelAnimationFrame(this._lastRecalculateAnimationFrame);
    }

    this._lastRecalculateAnimationFrame = window.requestAnimationFrame(() => {
      this.reCalculateColumnCount();
    });
  }

  reCalculateColumnCount() {
    const windowWidth = window && window.innerWidth || Infinity;
    let breakpointColsObject = this.props.breakpointCols; // Allow passing a single number to `breakpointCols` instead of an object

    if (typeof breakpointColsObject !== 'object') {
      breakpointColsObject = {
        default: parseInt(breakpointColsObject) || DEFAULT_COLUMNS
      };
    }

    let matchedBreakpoint = Infinity;
    let columns = breakpointColsObject.default || DEFAULT_COLUMNS;

    for (let breakpoint in breakpointColsObject) {
      const optBreakpoint = parseInt(breakpoint);
      const isCurrentBreakpoint = optBreakpoint > 0 && windowWidth <= optBreakpoint;

      if (isCurrentBreakpoint && optBreakpoint < matchedBreakpoint) {
        matchedBreakpoint = optBreakpoint;
        columns = breakpointColsObject[breakpoint];
      }
    }

    columns = Math.max(1, parseInt(columns) || 1);

    if (this.state.columnCount !== columns) {
      this.setState({
        columnCount: columns
      });
    }
  }

  itemsInColumns() {
    const currentColumnCount = this.state.columnCount;
    const itemsInColumns = new Array(currentColumnCount); // Force children to be handled as an array

    const items = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(this.props.children);

    for (let i = 0; i < items.length; i++) {
      const columnIndex = i % currentColumnCount;

      if (!itemsInColumns[columnIndex]) {
        itemsInColumns[columnIndex] = [];
      }

      itemsInColumns[columnIndex].push(items[i]);
    }

    return itemsInColumns;
  }

  renderColumns() {
    const {
      column,
      columnAttrs = {},
      columnClassName
    } = this.props;
    const childrenInColumns = this.itemsInColumns();
    const columnWidth = `${100 / childrenInColumns.length}%`;
    let className = columnClassName;

    if (className && typeof className !== 'string') {
      this.logDeprecated('The property "columnClassName" requires a string'); // This is a deprecated default and will be removed soon.

      if (typeof className === 'undefined') {
        className = 'my-masonry-grid_column';
      }
    }

    const columnAttributes = _objectSpread(_objectSpread(_objectSpread({}, column), columnAttrs), {}, {
      style: _objectSpread(_objectSpread({}, columnAttrs.style), {}, {
        width: columnWidth
      }),
      className
    });

    return childrenInColumns.map((items, i) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", _extends({}, columnAttributes, {
        key: i
      }), items);
    });
  }

  logDeprecated(message) {
    console.error('[Masonry]', message);
  }

  render() {
    const _this$props = this.props,
          {
      // ignored
      children,
      breakpointCols,
      columnClassName,
      columnAttrs,
      column,
      // used
      className
    } = _this$props,
          rest = _objectWithoutProperties(_this$props, ["children", "breakpointCols", "columnClassName", "columnAttrs", "column", "className"]);

    let classNameOutput = className;

    if (typeof className !== 'string') {
      this.logDeprecated('The property "className" requires a string'); // This is a deprecated default and will be removed soon.

      if (typeof className === 'undefined') {
        classNameOutput = 'my-masonry-grid';
      }
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", _extends({}, rest, {
      className: classNameOutput
    }), this.renderColumns());
  }

}

Masonry.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["Z"] = (Masonry);


/***/ }),

/***/ 26525:
/***/ (function(module) {

module.exports = function(md, options) {
  options = options || {};
  options.listUnicodeChar = options.hasOwnProperty('listUnicodeChar') ? options.listUnicodeChar : false;
  options.stripListLeaders = options.hasOwnProperty('stripListLeaders') ? options.stripListLeaders : true;
  options.gfm = options.hasOwnProperty('gfm') ? options.gfm : true;
  options.useImgAltText = options.hasOwnProperty('useImgAltText') ? options.useImgAltText : true;

  var output = md || '';

  // Remove horizontal rules (stripListHeaders conflict with this rule, which is why it has been moved to the top)
  output = output.replace(/^(-\s*?|\*\s*?|_\s*?){3,}\s*$/gm, '');

  try {
    if (options.stripListLeaders) {
      if (options.listUnicodeChar)
        output = output.replace(/^([\s\t]*)([\*\-\+]|\d+\.)\s+/gm, options.listUnicodeChar + ' $1');
      else
        output = output.replace(/^([\s\t]*)([\*\-\+]|\d+\.)\s+/gm, '$1');
    }
    if (options.gfm) {
      output = output
        // Header
        .replace(/\n={2,}/g, '\n')
        // Fenced codeblocks
        .replace(/~{3}.*\n/g, '')
        // Strikethrough
        .replace(/~~/g, '')
        // Fenced codeblocks
        .replace(/`{3}.*\n/g, '');
    }
    output = output
      // Remove HTML tags
      .replace(/<[^>]*>/g, '')
      // Remove setext-style headers
      .replace(/^[=\-]{2,}\s*$/g, '')
      // Remove footnotes?
      .replace(/\[\^.+?\](\: .*?$)?/g, '')
      .replace(/\s{0,2}\[.*?\]: .*?$/g, '')
      // Remove images
      .replace(/\!\[(.*?)\][\[\(].*?[\]\)]/g, options.useImgAltText ? '$1' : '')
      // Remove inline links
      .replace(/\[(.*?)\][\[\(].*?[\]\)]/g, '$1')
      // Remove blockquotes
      .replace(/^\s{0,3}>\s?/g, '')
      // Remove reference-style links?
      .replace(/^\s{1,2}\[(.*?)\]: (\S+)( ".*?")?\s*$/g, '')
      // Remove atx-style headers
      .replace(/^(\n)?\s{0,}#{1,6}\s+| {0,}(\n)?\s{0,}#{0,} {0,}(\n)?\s{0,}$/gm, '$1$2$3')
      // Remove emphasis (repeat the line to remove double emphasis)
      .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, '$2')
      .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, '$2')
      // Remove code blocks
      .replace(/(`{3,})(.*?)\1/gm, '$2')
      // Remove inline code
      .replace(/`(.+?)`/g, '$1')
      // Replace two or more newlines with exactly two? Not entirely sure this belongs here...
      .replace(/\n{2,}/g, '\n\n');
  } catch(e) {
    console.error(e);
    return md;
  }
  return output;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2302,1852,5675,4660,8611,638,1429,9774,2888,179], function() { return __webpack_exec__(57286); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);